import { useState } from 'react';
import { useUpdateUser } from '../user.service';
import { UpdateUserForm } from './update-user-form.component';
import { FormContainer } from '../../../_core/form/form-container.component';
import { IUpdateUserParams } from '../user.types';
import { logError, sleep } from '../../../../lib/utils';
import { resetFormMessages } from '../../../_core/form/form.helpers';
import { ICloseableDialogProps } from '../../../_core/core.types';

interface IUpdateUserContainerProps extends ICloseableDialogProps {
  givenName?: string | null;
  familyName?: string | null;
}

export const UpdateUserContainer = ({ close, givenName, familyName }: IUpdateUserContainerProps) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);
  const { updateUser } = useUpdateUser();

  const handleUpdate = async (props: IUpdateUserParams) => {
    try {
      await resetFormMessages({ setSubmitError, setSuccess });

      await updateUser(props);
      setSubmitError(null);
      setSuccess('Successfully updated user');
      sleep(250).then(close);
    } catch (err) {
      const errMsg = 'Unable to update user.';
      logError(errMsg, (err as Error).message);
      setSuccess(null);
      setSubmitError(errMsg);
    }
  };

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Update User"
    >
      <UpdateUserForm givenName={givenName} familyName={familyName} onSubmit={handleUpdate} />
    </FormContainer>
  );
};
